'use client';

import { HeldError } from '@storefront/shared-components/error-information/held-error';
import { RetryableError } from '@storefront/shared-components/error-information/retryable-error';
import ErrorClientWrapperVisID from '../v2/(purchase)/error.p';

type ErrorProps = {
  error: RetryableError | HeldError;
  resetErrorBoundary?: () => unknown;
};

export default function CustomError({ error }: Readonly<ErrorProps>) {
  return <ErrorClientWrapperVisID error={error} />;
}
